export class NewsletterCategoriesModel {
  constructor (newsletterCategoriesData = {}) {
    this.id = newsletterCategoriesData.id
    this.disabled = newsletterCategoriesData.disabled
    this.name = newsletterCategoriesData.name
    this.subcategories = newsletterCategoriesData.subcategories
  }
}
